import React from 'react'
import Font from '@cred/react-font'

const disclamers = {
  ups: (
    <>
      <Font type="disclaimer" className="mb-8">
        The full range of available rates varies by state. The average 3-year
        loan offered across all lenders using the Upstart platform will have an
        APR of 20% and 36 monthly payments of $35 per $1,000 borrowed (as of
        December 2019). There is no down payment and no prepayment penalty.
        Average APR is calculated based on 3-year rates offered in the last 1
        month. Your APR will be determined based on your credit, income, and
        certain other information provided in your loan application. Not all
        applicants will be approved.
      </Font>

      <Font type="disclaimer" className="mb-8">
        When you check your rate, we check your credit report. This initial
        (soft) inquiry will not affect your credit score. If you accept your
        rate and proceed with your application, we do another (hard) credit
        inquiry that will impact your credit score. If you take out a loan,
        repayment information will be reported to the credit bureaus.
      </Font>

      <Font type="disclaimer">
        Your loan amount will be determined based on your credit, income, and
        certain other information provided in your loan application. Not all
        applicants will qualify for the full amount. Loans are not available in
        West Virginia or Iowa. The minimum loan amount in MA is $7,000. The
        minimum loan amount in OH is $6,000. The minimum loan amount in NM is
        $5,100. The minimum loan amount in GA is $3,100.
      </Font>
    </>
  ),
  pro: (
    <>
      <Font type="disclaimer">
        For example, a three-year $10,000 loan with a Prosper Rating of AA would
        have an interest rate of 5.31% and a 2.41% origination fee for an annual
        percentage rate (APR) of 6.95% APR. You would receive $9,759 and make 36
        scheduled monthly payments of $301.10. A five-year $10,000 loan with a
        Prosper Rating of A would have an interest rate of 8.39% and a 5.00%
        origination fee with a 10.59% APR. You would receive $9,500 and make 60
        scheduled monthly payments of $204.64. Origination fees vary between
        2.41%-5%. APRs through Prosper range from 6.95% (AA) to 35.99% (HR),
        with the lowest rates for the most creditworthy borrowers. Eligibility
        for loans up to $40,000 depends on the information provided by the
        applicant in the application form. Eligibility is not guaranteed, and
        requires that a sufficient number of investors commit funds to your
        account and that you meet credit and other conditions. Refer to Borrower
        Registration Agreement for details and all terms and conditions. All
        loans made by WebBank, member FDIC.
      </Font>
    </>
  ),
  frp: (
    <>
      <Font type="disclaimer">
        The loan terms presented are not guaranteed and APRs presented are estimates only.  To obtain a loan you must submit additional information and documentation and all loans are subject to credit review and our approval process.  The range of APRs is 7.99% to 29.99% and your actual APR will depend upon factors including your credit score, usage and history, the requested loan amount, the stated loan purpose, and the term of the requested loan. To qualify for a 7.99% APR loan, a borrower will need excellent credit on a loan for an amount less than $12,000.00, and with a term equal to 24 months. Adding a co-borrower with sufficient income; using at least eighty-five percent (85%) of the loan proceeds to directly pay off qualifying existing debt; or showing proof of sufficient retirement savings, could help you also qualify for the lowest rate available. All loans are made by Cross River Bank and MetaBank®, N.A., Members FDIC.
      </Font>
    </>
  ),
  marlette: (
    <>
      <Font type="disclaimer">
        Best Egg loans are unsecured personal loans made by Cross River Bank, a
        New Jersey State Chartered Commercial Bank, Member FDIC. “Best Egg” is a
        trademark of Marlette Funding, LLC. All uses of “Best Egg” refer to “the
        Best Egg personal loan” and/or “Best Egg on behalf of Cross River Bank,
        as originator of the Best Egg personal loan,” as applicable. The term,
        amount and APR of any loan we offer to you will depend on your credit
        score, income, debt payment obligations, loan amount, credit history and
        other factors. Your loan agreement will contain specific terms and
        conditions. The timing of available funds upon loan approval may vary
        depending upon your bank’s policies. Loan amounts range from
        $2,000–$35,000. Residents of Massachusetts have a minimum loan amount of
        $6,500 ; New Mexico and Ohio, $5,000; and Georgia, $3,000. For a second
        Best Egg loan, your total existing Best Egg loan balances cannot exceed
        $50,000. Annual Percentage Rates (APRs) range from 5.99%–29.99%. The APR
        is the cost of credit as a yearly rate and reflects both your interest
        rate and an origination fee of 0.99%–6.99% of your loan amount, which
        will be deducted from any loan proceeds you receive. The origination fee
        on a loan term 4-years or longer will be at least 4.99%. Your loan term
        will impact your APR, which may be higher than our lowest advertised
        rate. You need a minimum 700 FICO® score and a minimum individual annual
        income of $100,000 to qualify for our lowest APR. To help the government
        fight the funding of terrorism and money laundering activities, Federal
        law requires all financial institutions to obtain, verify, and record
        information that identifies each person who opens an account. What this
        means for you: When you open an account, we will ask for your name,
        address, date of birth, and other information that will allow us to
        identify you. We may also ask to see your driver’s license or other
        identifying documents.
      </Font>
    </>
  ),
  marcus: (
    <>
      <Font type="disclaimer">
        Your loan terms are not guaranteed and are subject to our verification
        of your identity and credit information. To obtain a loan, you must
        submit additional documentation including an application that may affect
        your credit score. Rates will vary based on many factors, such as your
        creditworthiness (for example, credit score and credit history) and the
        length of your loan (for example, rates for 36 month loans are generally
        lower than rates for 72 month loans). Your maximum loan amount may vary
        depending on your loan purpose, income and creditworthiness. Your
        verifiable income must support your ability to repay your loan. Marcus
        by Goldman Sachs® is a brand of Goldman Sachs Bank USA and all loans are
        issued by Goldman Sachs Bank USA, Salt Lake City Branch. Applications
        are subject to additional terms and conditions.
      </Font>
    </>
  ),
  lightstream: (
    <>
      <Font type="disclaimer">
        All APRS reflect autopay and loyalty discounts where available. Payment Example: Monthly payment for a $10,000 loan at 9.84% APR with a term of three years would result in 36 monthly payments of $321.92.
      </Font>
    </>
  ),
  upgrade: (
    <>
      <Font type="disclaimer">
        Personal loans made through Upgrade feature APRs of 6.94%-35.97%. All personal loans have a 1.5% to 6% origination fee, which is deducted from the loan proceeds. Lowest rates require Autopay and paying off a portion of existing debt directly. For example, if you receive a $10,000 loan with a 36-month term and a 17.98% APR (which includes a 14.32% yearly interest rate and a 5% one-time origination fee), you would receive $9,500 in your account and would have a required monthly payment of $343.33. Over the life of the loan, your payments would total $12,359.97. The APR on your loan may be higher or lower and your loan offers may not have multiple term lengths available. Actual rate depends on credit score, credit usage history, loan term, and other factors. Late payments or subsequent charges and fees may increase the cost of your fixed rate loan. There is no fee or penalty for repaying a loan early. Personal loans issued by Upgrade's lending partners. Information on Upgrade's lending partners can be found at https://www.upgrade.com/lending-partners/.
      </Font>
    </>
  ),
  'lending-point': (
    <>
      <Font type="disclaimer">
        Loan approval is not guaranteed. Actual loan offers and loan amounts, terms and annual percentage rates (“APR”) may vary based upon LendingPoint’s proprietary scoring and underwriting system’s review of your credit, financial condition, other factors, and supporting documents or information you provide. Origination or other fees from 0% to 6% may apply depending upon your state of residence. Upon LendingPoint’s final underwriting approval to fund a loan, said funds are often sent via ACH the next non-holiday business day. LendingPoint makes loan offers from $2,000 to $25,000, at rates ranging from a low of 15.49% APR to a high of 35.99% APR, with terms from 24 to 48 months. The loan offer(s) shown reflect a 30 day payment cycle.
      </Font>
    </>
  ),
  ldc: (
    <>
      <Font type="disclaimer" className="mb-8">
        A representative example of loan payment terms is as follows: you receive a loan of $13,411 for a term of 36 months, with an interest rate of 12.16% and a 5.30% origination fee of $711, for an APR of 15.99%. In this example, you will receive $12,700 and will make 36 monthly payments of $446.46. Loan amounts range from $1,000 to $40,000 and loan term lengths are 36 months or 60 months. Some amounts and term lengths may be unavailable in certain states. APR ranges from 8.05% to 35.89% and is determined at the time of application. Origination fee ranges from 3% to 6% of the loan amount. Lowest APR is available to borrowers with excellent credit. Advertised rates are subject to change without notice.
      </Font>
      <br />
      <Font type="disclaimer" className="mb-8">
        Loans are made by LendingClub Bank, N.A., Member FDIC (“LendingClub Bank”), a wholly-owned subsidiary of LendingClub Corporation, NMLS ID 167439. Loans are subject to credit approval and sufficient investor commitment before they can be funded or issued. Certain information that we subsequently obtain as part of the application process (including but not limited to information in your consumer report, your income, the loan amount that your request, the purpose of your loan, and qualifying debt) will be considered and could affect your ability to obtain a loan from us. Loan closing is contingent on accepting all required agreements and disclosures at Lendingclub.com. “LendingClub” is a trademark of LendingClub Bank.
      </Font>
    </>
  ),
  payoff: (
    <>
      <Font type="disclaimer">
        This does not constitute an actual commitment to lend or an offer to
        extend credit. Upon submitting a loan application, you may be asked to
        provide additional documents to enable us to verify your income, assets,
        and financial condition. Your interest rate and terms for which you are
        approved will be shown to you as part of the online application process.
        Most applicants will receive a variety of loan offerings to choose from,
        with varying loan amounts and interest rates. Borrower subject to a loan
        origination fee, which is deducted from the loan proceeds. Refer to full
        borrower agreement for all terms, conditions and requirements.
      </Font>
    </>
  ),
  axos: (
    <>
      <Font type="disclaimer">
        Axos Bank provides personal loans from $5,000 to $35,000 – terms from 12
        to 60 months (for example, a $15,000 loan with an Annual Percentage Rate
        (APR) of 13.25% for 60 months has a payment of $326.06) – flexible
        lending criteria – funds deposited to your account in 12-48 hours – NO
        prepayment penalties, and preliminary offers that don’t impact your
        credit score – Consolidate credit card or other debt – Finance home
        improvements or major purchases – Set up an emergency fund – Whatever
        your goal, our experienced loan specialists can answer your questions
        and guide you through each step of the process – Axos Bank is an
        award-winning, FDIC-insured financial institution offering a wide range
        of products and services. NMLS #524995
      </Font>
    </>
  ),
  sofi: (
    <>
      <Font type="disclaimer">
        Fixed rates from 5.99% APR (with AutoPay) to 18.83% (without AutoPay). SoFi rate ranges are subject to change without notice. Not all applicants qualify for the lowest rate. If approved for a loan, to qualify for the lowest rate, you must have excellent credit and meet other conditions. Your actual rate will be within the range of rates listed above and will depend on a variety of factors, including credit score, credit usage and history, years of experience, our ability to verify your income and employment and other factors. The SoFi 0.25% AutoPay interest rate reduction applies if you make monthly principal and interest payments by an automatic monthly deduction from a savings or checking account. The benefit will discontinue and be lost for periods in which you do not pay by automatic deduction from a savings or checking account. AutoPay is not required to obtain a loan.
      </Font>
    </>
  ),
  ava: (
    <>
      <Font type="disclaimer">
        A $5,700 loan with an administration fee of 4.75% and an amount financed
        of $5,429.25, repayable in 36 monthly installments, would have an APR of
        29.95% and monthly payments of $230.33. Minimum loan amounts may vary by
        state. If approved, the actual rate and loan amount that a customer
        qualifies for may vary based on credit determination and other factors.
        An administration fee of up to 4.75% will be deducted from the loan
        proceeds. Avant branded credit products are issued by Webbank, member
        FDIC
      </Font>
    </>
  ),
}

export default disclamers
